import { Anchor, Breadcrumbs } from "@mantine/core"
import { Link } from "react-router-dom"

import { ADMIN_PATH, ADMIN_SONOMETER_PATH } from "_urls"
import { Sonometer } from "sonometer/types/sonometer.model"

export function SonometerBreadcrumbs({
    sonometer,
}: {
    sonometer?: Sonometer | "new"
}) {
    return (
        <Breadcrumbs separator="→">
            <Anchor component={Link} to={`/${ADMIN_PATH}`}>
                Admin
            </Anchor>
            <Anchor
                component={Link}
                to={`/${ADMIN_PATH}/${ADMIN_SONOMETER_PATH}`}
            >
                Sonometers
            </Anchor>
            {sonometer && sonometer !== "new" && sonometer.opponentName && (
                <span>{sonometer.opponentName}</span>
            )}
            {sonometer === "new" && <span>New</span>}
        </Breadcrumbs>
    )
}
